import React from 'react';
import VideoBackground from '../components/VideoBackground';
import SearchBar from '../components/SearchBar';
import FeaturedListings from '../components/FeaturedListings';
import ContactSection from '../components/ContactSection';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { useTranslations } from '../utils/translationDictionaries';
import { HOMEPAGE_VIDEO_URL, CERTIFICATIONS, MEMBERSHIPS } from '../utils/constants';
import './Home.css';

const Home = () => {
  const { language } = useLanguage();
  const { t } = useTranslations(language);

  return (
    <div className="home">
      <SEO 
        title="Casas en Venta en Puerto Rico | Alicea Realty Group"
        description="Casas en venta, alquiler y propiedades reposeídas en Puerto Rico. Asesoría de Noemí Alicea González, corredora autorizada."
        keywords="Alicea Realty Group, Noemi Alicea, Noemí Alicea González, bienes raíces Puerto Rico, real estate Puerto Rico, realtor Puerto Rico, propiedades Puerto Rico, casas en venta Puerto Rico, casas en alquiler Puerto Rico, Mid Island Association of REALTORS, San Juan, Bayamón, Caguas, Guaynabo, Carolina, Ponce, Mayagüez, alicearealtypr"
        ogTitle="Alicea Realty Group LLC | Bienes Raíces en Puerto Rico"
        ogDescription="Expertos en bienes raíces en Puerto Rico. Noemí Alicea González, Corredora Autorizada con más de 15 años de experiencia. Compra, venta y alquiler de propiedades."
        ogImage="https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Farg_logo_nobg.png?alt=media&token=53b347a3-8d9e-4e5a-8a1f-64b7cbc32e69"
        canonical="https://www.alicearealtypr.com/"
      />
      
      <section className="hero">
        <VideoBackground videoUrl={HOMEPAGE_VIDEO_URL}>
          <div className="hero-content">
            <h1>
              {language === 'es'
                ? 'Casas en Venta en Puerto Rico'
                : 'Homes for Sale in Puerto Rico'}
            </h1>
            <p>{t('home.heroSubtitle')}</p>
            <SearchBar />
          </div>
        </VideoBackground>
      </section>

      <FeaturedListings />

      <section className="features">
        <div className="container">
          <h2>{t('home.commitment')}</h2>

          <p style={{ fontSize: '1.3rem' }}>
            {t('home.commitmentText1')}
          </p>
          <br></br>
          <p style={{ fontSize: '1.3rem' }}>
            {t('home.commitmentText2')}
          </p>
        </div>
      </section>

      <section className="home-certifications">
        <div className="container">
          <h2>{t('home.certifications')}</h2>
          <div className="certifications-grid">
            {CERTIFICATIONS.map((cert) => (
              <div key={cert.id} className="certification-item">
                <img src={cert.src} alt={cert.alt} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="home-memberships">
        <div className="container">
          <h2>{t('home.memberships')}</h2>
          <div className="memberships-grid">
            {MEMBERSHIPS.map((m) => (
              <div key={m.id} className="membership-item">
                <img src={m.src} alt={m.alt} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <ContactSection />
    </div>
  );
};

export default Home;
